import React from 'react';
import { ListWrapper } from '@builtbypixel/nucleus';
import moment from 'moment';

import setup from './setup';

const extraMenu = () => null;

const List = () => {
  const columns = [
    {
      Header: 'ID',
      accessor: 'id',
    },
    {
      Header: 'Email',
      accessor: 'email',
    },
    {
      Header: 'Source',
      accessor: 'source',
    },
    {
      Header: 'Consent Given',
      accessor: 'consented_at.date',
      Cell: props => (props.value ? moment(props.value).format('LLL') : ''),
    },
    {
      Header: 'IP Address',
      accessor: 'ip_address',
    },
    {
      Header: 'Created',
      accessor: 'created_at.date',
      Cell: props => (props.value ? moment(props.value).format('LLL') : ''),
    },
  ];

  return <ListWrapper setup={setup} columns={columns} extraMenu={extraMenu} />;
};

export default List;
